export const RoomStatusTypes = {
    "0": "",
    "1": "clean",
    "2": "dirty",
    "3": "inspection"
}

export const MaintenanceStatusTypes = {
    "1": "Out Of Service",
    "2": "Out Of Order"
}

export const ReservationStatusTypes = {
    "1": "Reserved",
    "2": "CheckedIn",
    "3": "CheckedOut",
    "4": "NoShow",
    "5": "Cancelled",
    "6": "Arrived",
    "7": "Deleted",
    "8": "Released",
    "9": "Tentative",
    "10": "Option",
    "11": "WaitingList",
    "12": "Pre-Checkin"
}

export const ReservationStatusesEnums = {
    Reserved:   1,
    CheckedIn:  2,
    CheckedOut: 3,
    NoShow:     4,
    Cancelled:  5,
    Arrived:    6,
    Deleted:    7,
    Released:   8,
    Tentative:  9,
    Option:     10,
    WaitingList:11,
    PreCheckin: 12
}

export const RoomReservationStatusEnums = {
    '1': 'NoReservations',
    '2': 'ArrivesToday',
    '3': 'DeparturesToday',
    '4': 'StaysOver',
    '5': 'Other'
}

export const HousekeepingStatusEnums = {
    '1': 'Clean',
    '2': 'Dirty',
    '3': 'WaitingForInspection',
}

export const MaintenanceStatusEnums = {
    '1': 'OutOfService',
    '2': 'OutOfOrder',
    '3': 'OK',
}

export const ReceptionStatusEnums = {
    '1': 'FreeRoom',
    '2': 'BlockedRoom'
}
